import { Component, computed, inject, signal } from '@angular/core';
import { UploadWidgetService } from '../../services/upload-widget.service';
import { SequentialUploadService } from '../../services/sequential-upload.service';
import { CommonModule } from '@angular/common';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatIcon } from '@angular/material/icon';
import { FailedUploadItem, UploadFileNode } from '../../upload-folder.model';
import { MatTooltip } from '@angular/material/tooltip';
import { Button } from '../../../../../../shared/components/button/button';

@Component({
  selector: 'isc-upload-widget',
  imports: [CommonModule, MatProgressBarModule, MatIcon, MatTooltip, Button],
  templateUrl: './upload-widget.html',
  styleUrl: './upload-widget.scss',
})
export class UploadWidget {
  readonly widgetService = inject( UploadWidgetService );
  readonly uploadService = inject( SequentialUploadService );
  readonly uploadWidgetService = inject(UploadWidgetService);

  readonly expanded = signal(false);

  // retry(
  //   file: any
  // ): void {

  //   this.uploadService
  //     .retryFile(file);
  // }

//   close(
//   jobId: string
// ): void {

//   this.widgetService
//     .removeJob(jobId);
// }

close(jobId: string): void {

  this.widgetService.removeJob(
    jobId
  );
}

closeAll(): void {

  this.widgetService.clear();
}

retry(
  file: UploadFileNode
): void {

  this.uploadService.retryFile(
    file
  );
}

readonly canCloseAll =
  computed(() =>
    this.widgetService.jobs().every(
      job =>
        job.status === 'completed'
        ||
        job.status === 'failed'
        ||
        job.status === 'cancelled'
    )
  );

  cancel(jobId: string): void {
    this.widgetService.cancelJob(jobId);
    this.uploadWidgetService.uploadCompleted.set({timestamp: Date.now()});
  }

canRetry(
  item: FailedUploadItem
): boolean {

  return (
    item.retryAllowed
    &&
    !!item.file.parentFolderId
  );
}

confirmEmbed(jobId: string){
this.uploadWidgetService.confirmEmbed(jobId);
}
}
